import { AvailableTimeslotResponse } from "../contracts/AvailableTimeslotResponse";
import { AvailableTimeSlot } from "../models/AvailableTimeSlot";

/**
 * Mapper class for converting AvailableTimeslotResponse to AvailableTimeSlot
 */
export class AvailableTimeslotMapper {
  /**
   * Converts an AvailableTimeslotResponse to an AvailableTimeSlot model
   * The backend provides UTC timestamps which are passed through directly
   * @param response - The API response object with UTC timestamps
   * @returns The converted AvailableTimeSlot model
   */
  toAvailableTimeSlot = (
    response: AvailableTimeslotResponse
  ): AvailableTimeSlot => {
    return {
      // Store the UTC date as provided by the backend
      dateStart: response.dateStart,
      duration: response.duration,
      isWeekly: response.isWeekly,
    };
  };

  /**
   * Converts multiple AvailableTimeslotResponse objects to AvailableTimeSlot models
   * @param responses - Array of API response objects
   * @returns Array of converted AvailableTimeSlot models
   */
  toAvailableTimeSlots = (
    responses: AvailableTimeslotResponse[]
  ): AvailableTimeSlot[] => {
    return responses.map(this.toAvailableTimeSlot);
  };
}
